import { ref, computed } from 'vue';

/**
 * Yükleme durum verilerini oluşturur
 * @returns {Object} - Yükleme state verileri
 */
export const createUploadState = () => {
  // Yükleme için dosyalar
  const files = ref([]);
  const isLoading = ref(false);
  
  // Dosya genişletme durumu
  const expandedFiles = ref([]);
  const expandAll = ref(false);
  
  // Dosyalarda boş alanlar var mı kontrol et
  const hasEmptyFields = computed(() => {
    return files.value.some(file => 
      (!file.categoryIds || file.categoryIds.length === 0) || 
      !file.fileType
    );
  });
  
  // Yükleme özet metni
  const uploadSummary = computed(() => {
    if (files.value.length > 0) {
      return `${files.value.length} dosya yüklemeye hazır`;
    }
    return '';
  });
  
  // Yükleme devre dışı mı
  const isUploadDisabled = computed(() => {
    if (files.value.length > 0) {
      return files.value.some(file => 
        (!file.categoryIds || file.categoryIds.length === 0) || 
        !file.fileType
      );
    }
    return true;
  });

  return {
    files,
    isLoading,
    expandedFiles,
    expandAll,
    hasEmptyFields,
    uploadSummary,
    isUploadDisabled
  };
};